import {GOOD_RECEIVE_NOTE_LOADED} from "./ActionType";

export default function goodsReceiveNotes(state = [], action) {
  const {type, payload} = action;

  switch (type) {
    case GOOD_RECEIVE_NOTE_LOADED:
      return (state = payload);

    default:
      return state;
  }
}
